module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-hello.80277951.png";